import { render, staticRenderFns } from "./ver.vue?vue&type=template&id=4c253bde"
import script from "./ver.ts?vue&type=script&lang=js&external"
export * from "./ver.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c253bde')) {
      api.createRecord('4c253bde', component.options)
    } else {
      api.reload('4c253bde', component.options)
    }
    module.hot.accept("./ver.vue?vue&type=template&id=4c253bde", function () {
      api.rerender('4c253bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/sngpc/ver.vue"
export default component.exports